import Swiper, {Pagination} from "swiper";
import 'swiper/css/bundle';

Swiper.use( [Pagination] )


class PromotionSlider{
	constructor(el) {
		this.el         = el
		this.swiperEl   = el.querySelector( '.swiper' )
		this.pagination = el.querySelector( '.promo-slider__pagination' )

		this.init()
	}

	init() {
		const options = {
			autoHeight: true,
			loop: true,
			slidesPerView: 1.3,
			spaceBetween: 30,
			pagination: {
				el: this.pagination,
				clickable: true,
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 1,
				}
			},
		};
		this.Swiper   = new Swiper( this.swiperEl, options )
	}
}

(() => {
	Array.from( document.querySelectorAll( '.promo-slider' ) ).forEach( item => new PromotionSlider( item ) )
  })()
